"use strict";

exports.__esModule = true;
exports.applyTrailingSlashOption = void 0;
var endsWithSuffixes = (suffixes, input) => {
  for (var suffix of suffixes) {
    if (input.endsWith(suffix)) return true;
  }
  return false;
};
var suffixes = [".html", ".json", ".js", ".map", ".txt", ".xml", ".pdf"];
var applyTrailingSlashOption = function (input) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "always";
  if (input === "/") return input;
  var hasTrailingSlash = input.endsWith("/");
  if (endsWithSuffixes(suffixes, input)) {
    return input;
  }
  if (option === "always") {
    return hasTrailingSlash ? input : "".concat(input, "/");
  }
  if (option === "never") {
    return hasTrailingSlash ? input.slice(0, -1) : input;
  }
  return input;
};
exports.applyTrailingSlashOption = applyTrailingSlashOption;